export const SET_SUBTITLE = "SET_SUBTITLE";
export const SET_SUBTITLE_SYNC = "SET_SUBTITLE_SYNC";
export const VIDEO_SRC = "VIDEO_SRC";
export const VIDEO_SRC_NAME = "VIDEO_SRC_NAME";
export const VIDEO_IS_LOADING = "VIDEO_IS_LOADING";
export const SET_TIME = "SET_TIME";
export const SET_DURATION = "SET_DURATION";
export const SET_VOLUME = "SET_VOLUME";
export const SET_MUTE = "SET_MUTE";
export const SET_SPEED = "SET_SPEED";
export const SET_PLAYER_STATE = "SET_PLAYER_STATE";
export const SET_PLAYER_CONFIG = "SET_PLAYER_CONFIG";
export const ADD_ITEMS = "ADD_ITEMS";
export const SET_ITEMS = "SET_ITEMS";
export const SET_SELECTED_ITEMS = "SET_SELECTED_ITEMS";
export const REMOVE_ITEM_INDEX = "REMOVE_ITEM_INDEX";
export const REMOVE_ALL = "REMOVE_ALL";
export const UPDATE_ITEM = "UPDATE_ITEM";
export const SET_FONT_CONFIG = "SET_FONT_CONFIG";
export const SET_SYNC_CONFIG = "SET_SYNC_CONFIG";
export const SET_MODAL_OPEN = "SET_MODAL_OPEN";
export const SET_DRAWING_ENABLED = "SET_DRAWING_ENABLED";
export const SET_DRAWING_RECT = "SET_DRAWING_RECT";
export const SET_TOAST_TEXT = "SET_TOAST_TEXT";
export const SET_TOAST_TIMEOUT = "SET_TOAST_TIMEOUT";
export const SET_SUBTITLE_NAME = "SET_SUBTITLE_NAME";
export const SET_FILTER_PATH = "SET_FILTER_PATH";

export const PLAYER_ACTION = {
    BLUR : 'Blur',
    BLUR_EXTRA : 'Blur Extra',
    BLUR_EXTREME : 'Blur Extreme',
    BLUR_EXTREME_X2 : 'Blur Extreme_X2',
    BLACK : 'Black screen',
    SKIP : 'Skip',
    MUTE : 'Mute',
    NOACTION : 'No Action',
  }